var collapsible_list_pair_rtlignore_default = {
  "container": "SsjuQ",
  "title": "_1zxRS",
  "viewerContainer": "IxklI",
  "titleContainer": "FrpB3",
  "content": "RDnID",
  "expandIcon": "EYVzt",
  "dndIcon": "jMDPL",
  "RTL": "g-Vj1",
  "LTR": "E7Jny",
  "itemContainer": "gVaMS",
  "itemContainerViewer": "-fO-e",
  "mouseDown": "y-Oeu",
  "innerEditor": "POIz9",
  "item": "vTdWM",
  "floatingAddPluginMenuWrapper": "C06Ry"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
